module.exports = __webpack_public_path__ + "static/media/Rakesh.4e022e29.webp";